import React from "react";
import { ArrowRight } from "lucide-react";

export const PrimaryButton = ({
  children,
  onClick,
  disabled,
  testId,
  withArrow = true,
  type = "button",
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    data-testid={testId}
    className={`w-full rounded-2xl py-4 md:py-[18px] text-base md:text-lg font-semibold tracking-wide transition-all flex items-center justify-center gap-2 ${
      disabled
        ? "bg-gray-200 text-gray-400 cursor-not-allowed"
        : "bg-[#FF5E1A] hover:bg-[#E04F00] text-white cp-shadow-orange active:scale-[0.99]"
    }`}
  >
    {children}
    {withArrow && !disabled && <ArrowRight className="w-5 h-5" />}
  </button>
);

export const SecondaryButton = ({ children, onClick, testId }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className="w-full rounded-2xl py-4 text-base md:text-lg font-semibold glass hover:bg-white/70 hover:border-[#FF5E1A]/40 hover:text-[#FF5E1A] text-[#0F172A] transition-all"
  >
    {children}
  </button>
);
